import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';
import type { DeliverySettingsAPIDeliverySettingsView } from './types/DeliverySettingsAPIDeliverySettingsView';

const { publicRuntimeConfig } = getConfig() as NextConfig;
const DELIVERY_OPTIONS_ENDPOINT = publicRuntimeConfig.endpoints.deliverySettings;

// Swagger docs: https://delivery-settings.svc.qa.noths.com/swagger-ui.html#/delivery-settings-resource/getDeliverySettingsUsingGET
export const fetchPartnerDeliverySettings = async (
  partnerId: number,
): Promise<DeliverySettingsAPIDeliverySettingsView> => {
  const url = `${DELIVERY_OPTIONS_ENDPOINT}v1/partners/${partnerId}/delivery-settings/public`;

  const response = await fetchJSONWithTimeout(url, { timeout: 2000 });

  return await response.json();
};
